module.exports = __webpack_public_path__ + "static/img/AIGC设计-海报.5c47e3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC设计-海报.png
// module id = 1phg
// module chunks = 1